import axios from 'axios';

// eslint-disable-next-line @typescript-eslint/no-var-requires
require('dotenv').config();

const cognito = axios.create({
  baseURL: process.env.REACT_APP_base_url,
});

export default cognito;
